/**
 * Teams "Delivery mode" toggle — Webhook URL vs Microsoft 365 (OAuth). Shared by
 * ChannelCreate and ChannelDetail so the two stay in sync (DRY). Styling mirrors
 * the original inline detail toggle; tokens only.
 */
import { SegmentedControl } from '@vnetwork/ui/primitives';

export type TeamsMode = 'webhook' | 'oauth2';

export interface TeamsModeToggleProps {
  value: TeamsMode;
  onChange: (mode: TeamsMode) => void;
}

const MODE_ITEMS = [
  { value: 'webhook', label: 'Webhook URL' },
  { value: 'oauth2', label: 'Microsoft 365 (OAuth)' },
];

export function TeamsModeToggle({ value, onChange }: TeamsModeToggleProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--vn-space-2)', flexWrap: 'wrap' }}>
      <span style={{ fontSize: 'var(--vn-font-size-sm)', color: 'var(--vn-fg-muted)' }}>
        Delivery mode:
      </span>
      <SegmentedControl
        size="sm"
        items={MODE_ITEMS}
        value={value}
        onValueChange={(v) => onChange(v as TeamsMode)}
      />
    </div>
  );
}
